import React from 'react'
import { Alert } from 'react-bootstrap'

export const SearchAlert = ({ text }) => (
  <Alert variant='warning' role='alert'>
    {text}
  </Alert>
)
